// import moment from "moment";
import { Helmet } from "react-helmet";
import isEmpty from "../../utils/constants/isEmpty";
import { Suspense, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SbLoading from "../../components/common/SbLoading";
import { Route, Redirect, useLocation } from "react-router-dom";
import { getAllStoreDetails } from "../../redux/actions/storesAction";
import SbEmptyState from "../../components/common/Cards/SbEmptyState";
import { switchAccountType } from "../../redux/actions/demoAccountActions";
import { getSubscriptionStatus } from "../../redux/actions/paymentActions";
import { getCurrentUser, logoutCall } from "../../redux/actions/authActions";
import { getChannelHeadersDetails } from "../../redux/actions/channelsActions";
import {
  setUserProperty,
  initializeAmplitudeUser,
} from "../../utils/config/analytics";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [isLoading, toggleLoading] = useState(true);

  const user = useSelector((state) => state.auth?.user);
  const activePlan = useSelector((state) => state.payments?.activePlan);
  const storeDets = useSelector((state) => state.store?.businessDetails);
  const isDemoAccount = useSelector((state) => state.auth.isDemoAccount);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const storeId = storeDets?.store_id;
  const queryString = location.search;
  const query = new URLSearchParams(queryString);
  const isDemoQuery = query.get("demo");

  useEffect(() => {
    if (isAuthenticated) {
      // const obj = {
      //   id: user?.id,
      //   name: user?.name,
      //   email: user?.email,
      //   phone: user?.mobile?.number,
      //   createdAt: user?.created_at,
      //   country_code: user?.mobile?.country_code,
      // };
      dispatch(getCurrentUser());
      // window.analytics.identify(user?.id, obj);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      if (user?.id) {
        toggleLoading(true);
        dispatch(
          getAllStoreDetails(
            user?.group?.id,
            user?.group?.name,
            user?.custom_user_id
          )
        )
          .then(() => toggleLoading(false))
          .catch(() => toggleLoading(false));
      } else {
        toggleLoading(true);
        dispatch(getCurrentUser())
          .then(() => toggleLoading(false))
          .catch(() => toggleLoading(false));
      }
    }
  }, [isAuthenticated, user?.id]);

  useEffect(() => {
    if (isAuthenticated && !isEmpty(activePlan) && !isEmpty(user)) {
      // checkforSegEvnt(user, activePlan);

      // for ampitude user updates
      initializeAmplitudeUser(user?.id, user);

      const isBrandOwner = !user?.role?.key;
      const userType = isBrandOwner
        ? user?.group?.id
          ? "multi_outlet"
          : "single_outlet"
        : user?.stores?.value?.length > 1
        ? "multi_store"
        : "single_store";

      setUserProperty("type", userType);
      setUserProperty("plan", activePlan?.plan);
    }
  }, [activePlan, isAuthenticated, user]);

  useEffect(() => {
    if (isDemoQuery && !isDemoAccount) {
      dispatch(switchAccountType(true));
    } else if (!isDemoQuery && isDemoAccount) {
      dispatch(switchAccountType(false));
    }
    // eslint-disable-next-line
  }, [isDemoQuery]);

  useEffect(() => {
    if (storeId) {
      dispatch(getChannelHeadersDetails(storeId));
      dispatch(getSubscriptionStatus(storeId));
    }
  }, [storeId]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated) {
          window.dataLayer?.push({
            event: "gtm.load",
            pathname: props.location.pathname,
          });
          window.dataLayer?.push({
            event: "gtm.dom",
            pathname: props.location.pathname,
          });
          window.dataLayer?.push({
            event: "page_view",
            pathname: props.location.pathname,
          });
          return isLoading ? (
            <SbLoading fullPage={true} />
          ) : (
            <Suspense fallback={<SbLoading fullPage={true} />}>
              {user?.id &&
                import.meta.env.VITE_CUSTOM_NODE_ENV === "production" && (
                  <Helmet>
                    <script>
                      {`
                  var beamer_config = {
                    product_id : '${import.meta.env.VITE_BEEMER_ID}',
                    user_id: '${user?.id}',
                    user_firstname: '${user?.name}',
                    user_email: '${user?.email}',
                  };
                `}
                    </script>
                    <script
                      defer="defer"
                      type="text/javascript"
                      src="https://app.getbeamer.com/js/beamer-embed.js"
                    ></script>
                  </Helmet>
                )}
              {storeDets?.noActiveStore ? (
                <SbEmptyState
                  isBtn={true}
                  btnText="Logout"
                  img="/assets/images/ufo.svg"
                  btnHandleClick={() => dispatch(logoutCall())}
                  title="No active stores found in your account."
                />
              ) : (
                <Component {...props} />
              )}
            </Suspense>
          );
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

export default PrivateRoute;

// const checkforSegEvnt = (user, activePlan) => {
//   // for first time login events
//   const initialSegEvnt = {
//     userId: user?.id,
//     freeTrialExpired: false,
//     after7dayFreeTrial: false,
//     in1WeekPaidPlans: false,
//     in3WeeksPaidPlans: false,
//     in6WeeksPaidPlans: false,
//   };

//   if (!localStorage.segmentEvents) {
//     localStorage.setItem("segmentEvents", JSON.stringify(initialSegEvnt));
//   } else {
//     let segEvnt =
//       localStorage.segmentEvents && JSON.parse(localStorage.segmentEvents);

//     if (segEvnt?.userId !== user?.id) {
//       segEvnt = { ...initialSegEvnt };
//     }

//     // const obj = {
//     //   name: user?.name,
//     //   email: user?.email,
//     //   number: user?.mobile?.number,
//     //   country_code: user?.mobile?.country_code,
//     // };

//     if (activePlan?.plan === "forever_free") {
//       if (segEvnt?.freeTrialExpired === false) {
//         // window.analytics.track("FirstTimeLoginAfterFreeTrial", obj);
//         localStorage.setItem(
//           "segmentEvents",
//           JSON.stringify({ ...segEvnt, freeTrialExpired: true })
//         );
//       }
//     } else if (activePlan?.plan === "free_trial") {
//       const freeTrialDaysLeft = moment(activePlan?.ends_at)
//         .startOf("day")
//         .diff(moment().startOf("day"), "days");
//       if (freeTrialDaysLeft < 8 && segEvnt?.after7dayFreeTrial === false) {
//         // window.analytics.track("FirstTimeLoginAfterSevenDayFreeTrial", obj);
//         localStorage.setItem(
//           "segmentEvents",
//           JSON.stringify({ ...segEvnt, after7dayFreeTrial: true })
//         );
//       }
//     } else if (
//       activePlan?.plan === "starter" ||
//       activePlan?.plan === "growth"
//     ) {
//       let dateAfter1Week;
//       let dateAfter3Weeks;
//       let dateAfter6Weeks;
//       const todaysDate = moment();

//       if (activePlan?.subscription_period === "Monthly") {
//         dateAfter1Week = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "month")
//           .add(1, "weeks");
//         dateAfter3Weeks = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "month")
//           .add(3, "weeks");
//         dateAfter6Weeks = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "month")
//           .add(6, "weeks");
//       } else {
//         dateAfter1Week = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "year")
//           .add(1, "weeks");
//         dateAfter3Weeks = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "year")
//           .add(3, "weeks");
//         dateAfter6Weeks = moment(activePlan?.ends_at, "dddd Do MMMM, YYYY")
//           .subtract(1, "year")
//           .add(6, "weeks");
//       }

//       if (
//         todaysDate.isBetween(
//           activePlan?.subscription_period === "Monthly"
//             ? moment(activePlan?.ends_at, "dddd Do MMMM, YYYY").subtract(
//                 1,
//                 "month"
//               )
//             : moment(activePlan?.ends_at, "dddd Do MMMM, YYYY").subtract(
//                 1,
//                 "year"
//               ),
//           dateAfter1Week
//         ) &&
//         segEvnt?.in1WeekPaidPlans === false
//       ) {
//         // window.analytics.track("FirstTimeLoginInOneWeekPaidPlan", obj);
//         localStorage.setItem(
//           "segmentEvents",
//           JSON.stringify({ ...segEvnt, in1WeekPaidPlans: true })
//         );
//       } else if (
//         todaysDate.isBetween(dateAfter1Week, dateAfter3Weeks) &&
//         segEvnt?.in3WeeksPaidPlans === false
//       ) {
//         // window.analytics.track("FirstTimeLoginInThreeWeeksPaidPlan", obj);
//         localStorage.setItem(
//           "segmentEvents",
//           JSON.stringify({ ...segEvnt, in3WeeksPaidPlans: true })
//         );
//       } else if (
//         todaysDate.isBetween(dateAfter3Weeks, dateAfter6Weeks) &&
//         segEvnt?.in6WeeksPaidPlans === false
//       ) {
//         // window.analytics.track("FirstTimeLoginInSixWeeksPaidPlan", obj);
//         localStorage.setItem(
//           "segmentEvents",
//           JSON.stringify({ ...segEvnt, in6WeeksPaidPlans: true })
//         );
//       }
//     }
//   }
// };
